<template>
    <Head title="Email Verification" />

    <jet-authentication-card>
        <div class="flex flex-col text-center w-full mb-4">
            <LogoAppSquare class="h-24 w-24 m-auto" />
        </div>

        <div class="mb-4 text-sm text-gray-600">
            Sorry, your email <span class="text-red-600">can not</span> be verified. Please recheck your email inbox and click on the link to verify your email again.
        </div>

        <form @submit.prevent="submit">
            <div class="mt-4 flex items-center justify-end">
                <Link
                    :href="route('login')"
                    class="
                        underline
                        text-sm text-blue-700
                        hover:text-[#4338CA]
                        font-semibold
                    "
                    >Log In</Link
                >
            </div>
        </form>
    </jet-authentication-card>
</template>

<script>
import { defineComponent } from "vue";
import JetAuthenticationCard from "@/Jetstream/AuthenticationCard.vue";
import LogoAppSquare from "@/Logo/LogoAppSquare";
import { Head, Link } from "@inertiajs/inertia-vue3";

export default defineComponent({
    components: {
        Head,
        JetAuthenticationCard,
        LogoAppSquare,
        Link,
    },

    data() {
        return {};
    },

    methods: {},
});
</script>
